import React from "react";

const Subscribe = () => {
  return (
    <section className="section bg-light text-dark text-center position-relative">
      <div className="container">
        <h2 className="text-dark mb-3">Subscribe For New Features</h2>
        <div className="col-lg-6 col-md-8 mx-auto">
          <p className="pb-4">
            Stay updated with the latest features — get exclusive access to
            product updates and proven tips to grow your store.
          </p>
        </div>

        <form className="row justify-content-center mt-3 gx-2">
          <div className="col-lg-6 col-md-8 position-relative">
            <input
              type="email"
              className="sub-btn sub form-control pe-5 mx-auto"
              placeholder="Email Address..."
              style={{ height: "45px" }}
            />
            <button
              type="submit"
              className="btn btn-primary position-absolute top-0 end-0 h-100"
              style={{
                borderTopLeftRadius: "30px",
                borderBottomLeftRadius: "30px",
                width: "180px",
              }}
            >
              Subscribe
            </button>
          </div>
        </form>
      </div>
      {/*
      <div className="features-shape-1">
        <img src="assets/images/shape-6.png" alt="" />
      </div>
      */}
    </section>
  );
};

export default Subscribe;
